var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 19C14.7467 19 19 14.7467 19 9.5C19 4.25329 14.7467 0 9.5 0C4.25329 0 0 4.25329 0 9.5C0 14.7467 4.25329 19 9.5 19ZM5.61014 5.61014C3.46329 7.757 3.46329 11.243 5.61014 13.3899C7.75699 15.5367 11.243 15.5367 13.3899 13.3899C15.5367 11.243 15.5367 7.75699 13.3899 5.61014C11.243 3.46329 7.75699 3.46329 5.61014 5.61014ZM6.2358 12.7642C4.54951 11.0779 4.4416 8.40718 5.91205 6.59489L12.4051 13.0879C10.5928 14.5584 7.92208 14.4505 6.2358 12.7642ZM13.0919 12.4003C14.5582 10.5881 14.449 7.92057 12.7642 6.2358C11.0794 4.55102 8.41194 4.44179 6.59975 5.90812L13.0919 12.4003Z",
    fill: "#FC7900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFilledIcon);
export default __webpack_public_path__ + "static/media/notFilledIcon.6d8511fe09464f0a34196b01bbb068d3.svg";
export { ForwardRef as ReactComponent };